<template>
  <v-container fluid fill-height style="max-height: 100vh">
    <v-layout justify-center align-center column pa-2>
      <h3 class="mb-3">
        Facebook Data Deletion Instructions URL for Simple Login
      </h3>
      <div>
        Simple Login is a facebook login app and we do not save your personal
        data in our server. According to Facebook policy, we have to provide
        User Data Deletion Callback URL or Data Deletion Instructions URL. If
        you want to delete your activities for Simple Login App, you can remove
        your information by following these steps:
        <ul class="mt-2">
          <li>
            Go to your Facebook Account’s Setting & Privacy. Click “Settings”
          </li>
          <li>
            Look for “Apps and Websites” and you will see all of the apps and
            websites you linked with your Facebook.
          </li>
          <li>Search and Click “Simple Login” in the search bar.</li>
          <li>Scroll and click “Remove”.</li>
          <li>
            Congratulations, you have succesfully removed your app activities.
          </li>
        </ul>
      </div>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "FbDataDeletionInstructions",
};
</script>